import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

/**
 * Mutation hook for POST admin/accountProfile/regenerate.
 * Calls the backend to extract discrete content preference fields from
 * an existing businessDescription using AI. Does NOT save — the admin
 * reviews and confirms before saving.
 */
export function useAdminAccountProfileRegenerateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (params: { impersonationContext?: Api.IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<Api.AccountProfile>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/accountProfile/regenerate',
					impersonationContext: params.impersonationContext,
				}),
				'POST'
			);
		},
		onSuccess,
		onError,
	});
}
